interface ImageMap {
    [key: string]: string;
}

// no localized image for hu, it, ko, nl, pl, zh
const devOpsSectionImageMap: ImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/v3346kr200jcjn6s25r1tt30u5v176vq.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/m6c87uds2rmr01d1l0nvt7rw1853543q.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/3gy5t516exvp226f8s16140ljfgjtt4b.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/3klwx86641ord17j6csodsaw3c8pmb4o.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/wwld70kj01143q7442d6cr0s8745ekyr.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/0fuw156nx8m1s3l553w5pbab3jb8766y.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/e6qwe41p1rm72s4qh1u7tia2sbp1jm38.webp"
};

// no localized images available for the placeholder image for the plan tab video
const planTabsSectionImageMap: ImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/8q22ns81pbey0cqxk25j50spls50mw41.webp"
};

// no localized image for hu, it, ko, nl, pl, zh
const planTabsSectionVideoMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/JSW-Plan.mp4",
    ja: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/JA/JSW-Plan-JA.mp4",
    de: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/DE/JSW-Plan-DE.mp4",
    es: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/ES/JSW-Plan-ES.mp4",
    fr: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/FR/JSW-Plan-FR.mp4",
    br: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/PT/JSW-Plan-PT-BR.mp4",
    ru: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/RU/JSW-Plan-RU.mp4"
};

// no localized images available
const trackTabsSectionImageMap: ImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/5hde3vyy76yd4faeeu3mqp4yqss4500q.webp"
};

// no localized images available
const releaseTabsSectionImageMap: ImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/e8i1y7s0mnma07f7xkvby25ju08227hx.webp"
};

// no localized images available
const reportTabsSectionImageMap: ImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/c7w6yj6wl0skhah2wt56dv8q235782wp.webp"
};

// no localized images available
const automateTabsSectionImageMap: ImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/4h4430vktkydp6sxq3a5ivtl85da683b.webp"
};

// no localized images available
const scailingJiraFreeImageMap: ImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp"
};

// no localized image for hu, it, ko, nl, pl, zh
const workflowSectionImageMap: ImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/o575pga731f3k7yeis26nm4631uc0688.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/8588gx77hlb7264626g7a25nie6083g1.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/s2rjykhu0l4cqe7i4x7ceq5i0e53eq6k.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/ti8xa750n8crthi0j41qq7md8b6m7845.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/5x4k2x175h54lv0378p6t0qoasuisby1.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/fsf33t0bun5g672x8ni1f0w713r8iem4.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/tk1o6v4elgjklv6lot8ml1m52t318304.webp"
};

export const getDevOpsSectionImage = (locale: string): string => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return devOpsSectionImageMap[locale] || devOpsSectionImageMap["en"]!;
};

export const getPlanTabsSectionImage = (locale: string): string => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return planTabsSectionImageMap[locale] || planTabsSectionImageMap["en"]!;
};

export const getPlanTabsSectionVideo = (locale: string): string => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return planTabsSectionVideoMap[locale] || planTabsSectionVideoMap["en"]!;
};

export const getTrackTabsSectionImage = (locale: string): string => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return trackTabsSectionImageMap[locale] || trackTabsSectionImageMap["en"]!;
};

export const getReleaseTabsSectionImage = (locale: string): string => {
    return (
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        releaseTabsSectionImageMap[locale] || releaseTabsSectionImageMap["en"]!
    );
};

export const getReportTabsSectionImage = (locale: string): string => {
    return (
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        reportTabsSectionImageMap[locale] || reportTabsSectionImageMap["en"]!
    );
};

export const getAutomateTabsSectionImage = (locale: string): string => {
    return (
        automateTabsSectionImageMap[locale] ||
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        automateTabsSectionImageMap["en"]!
    );
};

export const getWorkflowSectionImage = (locale: string): string => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return workflowSectionImageMap[locale] || workflowSectionImageMap["en"]!;
};

export const getScailingSectionJiraFreeImage = (locale: string): string => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return scailingJiraFreeImageMap[locale] || scailingJiraFreeImageMap["en"]!;
};
